import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { Target, CalendarBold } from '@oca/icons';
import { Typography } from '../atoms/typography';
// eslint-disable-next-line import/no-cycle
import { AssigneeList } from './assignee-list';
import { Divider } from '../atoms';
import PriorityBadge from '../molecules/prio-badge';

export const TaskCard = React.forwardRef(function TaskCard(props, ref) {
  const { assignees, dueDate, formatStr, priority, title } = props;

  return (
    <Wrapper bg="fillPrimary" ref={ref}>
      <Backdrop padding={3}>
        <Flex alignItems="center" style={{ gap: 6 }} marginBottom={3}>
          <Target />
          <Typography
            color="textSecondary"
            fontWeight={500}
            width={1}
            variant="h4"
          >
            {title}
          </Typography>
        </Flex>
        <Box>
          <AssigneeList assignees={assignees} linkToAssignee={null} />
        </Box>
        <Divider color="#E9EAEB" style={{ margin: '16px 0px' }} />
        <Flex alignItems="center" justifyContent="space-between">
          <PriorityBadge level={priority} />
          <Flex alignItems="center" style={{ gap: 4 }}>
            <CalendarBold />
            <Typography color="textSecondary">
              {dueDate ? dayjs(new Date(dueDate)).format(formatStr) : '---'}
            </Typography>
          </Flex>
        </Flex>
      </Backdrop>
    </Wrapper>
  );
});

TaskCard.propTypes = {
  assignees: PropTypes.arrayOf(
    PropTypes.shape({
      avatar: PropTypes.string,
    }),
  ),
  dueDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  formatStr: PropTypes.string,
  priority: PropTypes.string,
  title: PropTypes.node,
};

TaskCard.defaultProps = {
  assignees: [],
  dueDate: null,
  formatStr: 'MMM D, HH:mm',
  priority: null,
  title: null,
};

const Wrapper = styled(Box)`
  border-radius: 12px;
  overflow: hidden;
  padding-left: 4px;
`;

const Backdrop = styled(Box)`
  position: relative;
  background: rgba(255, 255, 255, 0.95);
`;
